import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const themes = {
  minimal: {
    id: 'minimal',
    name: 'Claire Minimaliste',
    description: 'Blanc pur, noir, accent bleu discret',
    style: 'Apple, Stripe, Shopify'
  },
  elegant: {
    id: 'elegant',
    name: 'Neutre Elegante',
    description: 'Gris anthracite, accent violet',
    style: 'Notion, Linear, Vercel'
  },
  dark: {
    id: 'dark',
    name: 'Sombre Moderne',
    description: 'Dark mode, accent vert menthe',
    style: 'GitHub Dark, Raycast'
  },
  organic: {
    id: 'organic',
    name: 'Terre Organique',
    description: 'Tons chauds, accent vert olive',
    style: 'Style unique et chaleureux'
  }
};

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    const saved = localStorage.getItem('waago-theme');
    return saved || 'minimal';
  });

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('waago-theme', theme);
  }, [theme]);

  const value = {
    theme,
    setTheme,
    themes
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}

export default ThemeContext;
